import { render, staticRenderFns } from "./RmaModal.vue?vue&type=template&id=1c7810aa&"
import script from "./RmaModal.vue?vue&type=script&lang=js&"
export * from "./RmaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports